(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('nasrac-admin-user-account', {
            parent: 'nasrac-admin',
            url: '/nasrac-admin-user-account',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminUserAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-accounts.html',
                    controller: 'NasracAdminUserAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminUserAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nasrac-admin-user-account-detail', {
            parent: 'nasrac-admin-user-account',
            url: '/nasrac-admin-user-account/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminUserAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-detail.html',
                    controller: 'NasracAdminUserAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminUserAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NasracAdminUserAccount', function($stateParams, NasracAdminUserAccount) {
                    return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nasrac-admin-user-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nasrac-admin-user-account-detail.edit', {
            parent: 'nasrac-admin-user-account-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-user-account.new', {
            parent: 'nasrac-admin-user-account',
            url: '/new',
            data: {
                authorities: roles,
                isSiteIdEnable:false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                login: null,
                                password: null,
                                lastName: null,
                                displayName: null,
                                email: null,
                                id: null,
                                securityRoles: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('nasrac-admin-user-account');
                });
            }]
        })
        .state('nasrac-admin-user-account.edit', {
            parent: 'nasrac-admin-user-account',
            url: '/{id}/edit',
            data: {
                authorities: roles,
                isSiteIdEnable:true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-user-account.delete', {
            parent: 'nasrac-admin-user-account',
            url: '/{id}/delete',
            data: {
                authorities: roles,
                isSiteIdEnable:true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-delete-dialog.html',
                    controller: 'NasracAdminUserAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
